import React from "react";
import loadImage from "blueimp-load-image";
import Select, { components } from "react-select";
import _ from "lodash";

import "./AddRetailerModal.css";
import {
  RetailerTypesOptions,
  TerritoryOptions,
} from "../../../Constants/retailer";

const UKIcon = require("../../../assets/media/countries/uk.png");
const USAIcon = require("../../../assets/media/countries/usa.png");
const IrelandIcon = require("../../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../../assets/media/countries/australia.png");
const FranceIcon = require("../../../assets/media/countries/france.png");
const GermanIcon = require("../../../assets/media/countries/german.png");
const IndiaIcon = require("../../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon
};

const MenuList = (props) => {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option) => (
        <div
          className="territory-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          <img src={TerritoryIcon[option.value]} alt="type" />
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
};

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div className="territory-selected-value">
        <img src={TerritoryIcon[data.value]} alt="type" />
        {data.label}
      </div>
    </components.SingleValue>
  );
};

class AddRetailerModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      retailerName: "",
      retailerType: RetailerTypesOptions[0],
      territory: {
        value: TerritoryOptions[0],
        label: TerritoryOptions[0],
      },
    };
  }

  onSave = (event) => {
    event.stopPropagation();
    const { onSave } = this.props;
    const {
      retailerName,
      retailerType,
      logo,
      background,
      ecopayLogo,
      territory,
    } = this.state;
    if (!retailerName) {
      alert("Retailer name is required.");
      return;
    }

    if (!logo) {
      alert("You should select one logo.");
      return;
    }

    if (!background) {
      alert("You should select one background image.");
      return;
    }

    if (!ecopayLogo) {
      alert("You should select one ecopay logo image.");
      return;
    }

    onSave(
      retailerName,
      retailerType.value,
      logo,
      background,
      ecopayLogo,
      territory.value
    );
  };

  handleChangeType = (retailerType) => {
    this.setState({ retailerType });
  };

  handleChangeTerritory = (territory) => {
    this.setState({ territory });
  };

  onNameHandler = (event) => {
    this.setState({
      retailerName: event.target.value,
    });
  };

  selectedFile = (e) => {
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };

  render() {
    const { retailerName, retailerType, territory } = this.state;
    const { id, initialValue } = this.props;

    return (
      <div
        className="modal fade add-retailer-modal"
        id={id ? `retailer-modal-${id}` : "retailer-modal"}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {initialValue ? "Edit" : "Add"} Retailer
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div
                style={{
                  marginBottom: 10,
                }}
              >
                <p className="section-title">Retailer Name</p>
                <input
                  className="form-control form-control-lg form-control-alt"
                  name="retailerName"
                  placeholder="Input retailer name here..."
                  onChange={this.onNameHandler}
                  value={retailerName}
                />
                <p className="section-title">Territory</p>
                <div className="territory-container">
                  <Select
                    value={territory}
                    onChange={this.handleChangeTerritory}
                    options={TerritoryOptions.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                    isSearchable={false}
                    components={{ MenuList, SingleValue }}
                  />
                </div>
                <p className="section-title">Logo</p>
                <input
                  type="file"
                  id="logo"
                  accept="image/*"
                  onChange={this.selectedFile}
                />
                <p className="section-title">Background</p>
                <input
                  type="file"
                  id="background"
                  accept="image/*"
                  onChange={this.selectedFile}
                />
                <p className="section-title">EcoPay Logo</p>
                <input
                  type="file"
                  id="ecopayLogo"
                  accept="image/*"
                  onChange={this.selectedFile}
                />
                <p className="section-title">Retailer type</p>
                <div className="retailer-type-container">
                  <Select
                    placeholder="Retailer type"
                    value={retailerType}
                    onChange={this.handleChangeType}
                    options={RetailerTypesOptions}
                    isSearchable={false}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.onSave}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddRetailerModal;



// WEBPACK FOOTER //
// ./src/components/Retailer/AddRetailerModal/AddRetailerModal.js